import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertVendorGroup from "../../../components/vendorGroupComponent/insertVendorGroup";
import { translate } from "react-i18next";

class VendorGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: localStorage.getItem('customerNumber') != 1158 ? "add_vendor_title" : "add_title",
      editData: {},
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }
  }

  onFormSubmit = () => {
    this.props.history.push("/vendor-group");
    // this.props.history.go();
  };
  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.props.t(this.state.title)} LinkName="/vendor-group" />
        <div className="m-2">
          <InsertVendorGroup
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default translate("vendor_group")(VendorGroup);
